import { snakeCaseToTitleCase } from './utils';
import {
  FeatureEnum,
  GroupIdEnum,
  OwnerEnum,
  TContext,
  TProperties,
} from './types';

export const GENERAL_LIBRARY_NAME = 'general-library';

type BuildJusfyEventsPropertiesInput = {
  event: string;
  feature: FeatureEnum;
  eventMeaning: string;
  relevantUserActivity: boolean;
  extraProperties?: Partial<TProperties>;
  owner?: OwnerEnum;
};

export function buildJusfyEventsProperties({
  event,
  feature,
  eventMeaning,
  relevantUserActivity,
  extraProperties = {},
  owner = OwnerEnum.JORNADA,
}: BuildJusfyEventsPropertiesInput): TProperties {
  return {
    ...extraProperties,
    owner,
    feature,
    event_meaning: eventMeaning,
    relevant_user_activity: relevantUserActivity,
    event_text: snakeCaseToTitleCase(event),
  } as TProperties;
}

type BuildJusfyEventsContextInput = {
  groupId?: GroupIdEnum | string;
  libraryName?: string;
  component: string;
};

export function buildJusfyEventsContext({
  groupId = GroupIdEnum.GENERAL_GROUP,
  libraryName = GENERAL_LIBRARY_NAME,
  component,
}: BuildJusfyEventsContextInput): TContext {
  return {
    groupId,
    library: {
      name: libraryName,
      componente: component,
    },
  };
}
